/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// window.$ = require('jquery');
// require('./bootstrap');
window.axios = require("axios");
window.Vue = require("vue");
// window.moment = require('moment');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffloding to fit your unique needs.

 */
Vue.component("modal", {
  template: "#modals-template",
});
var ba = new Vue({
  el: "#appoint",
  data: {
    step: 1,
    getBookApp: {
      fullNameApp: null,
      emailApp: null,
      phoneNoApp: null,
      sourceApp: null,
    },
    errorMessages: {
      fullNameApp: null,
      emailApp: null,
      phoneNoApp: null,
      sourceApp: null,
    },
    allerros: [],
    stepError: "",
    bookAppointment: false,
    scheduleTimes: "",
    appDate: "",
    appTime: "",
    appDetail: {
      full_name: "",
      email: "",
      phone_no: "",
      source: "",
      username: "",
      budget: "",
      time: "",
      date: "",
    },
    timeFields: {
      sign: "",
      country: "",
      hr: "",
      min: "",
    },
    cnt: null,
    scheduleTimesList: 0,
  },
  mounted: function () {
    var vm = this;
    $("#datepicker").datepicker({
      beforeShowDay: $.datepicker.noWeekends,
      dateFormat: "dd-mm-yy",
      minDate: 0,
      onSelect: function (dateText, inst) {
        vm.appDate = dateText;
        vm.showTime(dateText);
      },
    });
    this.getHomeDetail();
  },
  methods: {
    getHomeDetail: function () {
      var vm = this;
      axios.get("/get_home_detail").then(function (response) {
        vm.timeFields.sign = response.data.sign;
        vm.timeFields.country = response.data.country;
        vm.timeFields.hr = response.data.hr;
        vm.timeFields.min = response.data.min;
      });
    },
    showTime: function (dateText) {
      var vm = this;
      this.timeFields.dateText = dateText;
      axios
        .post("/show_appointment_time", this.timeFields)
        .then(function (response) {
          vm.scheduleTimes = response.data.times;
          vm.scheduleTimesList = response.data.times.length;
        });
    },
    appointTime: function (startTime, index) {
      var a = this.cnt;
      if (a != null) {
        0;
        $("#timeselected" + a).removeClass("active");
      }
      a = this.cnt = parseInt(index);
      $("#timeselected" + index).addClass("active");
      this.appTime = startTime;
    },
    scheduleAppointment: function () {
      var appTimes = this.appTime;
      var appDates = this.appDate;
      var vm = this;
      if (appTimes != "" && appDates != "") {
        vm.step = 2;
        let ckeditor = document.createElement("script");
        ckeditor.setAttribute("src", "https://www.google.com/recaptcha/api.js");
        document.head.appendChild(ckeditor);
      } else {
        alert("Please select date and time");
      }
    },
    scheduleAppointmentsubmit: function () {
      this.appDetail.time = this.appTime;
      this.appDetail.date = this.appDate;
      var vm = this;
      axios
        .post("/book_appointment", this.appDetail)
        .then(function (response) {
          if (response.data.msg == "success") {
            vm.step = 3;
          } else {
            alert("Appointment already booked");
          }
        })
        .catch(function (error) {
          vm.allerros = error.response.data.errors;
          vm.success = false;
          console.log(error);
        });
    },
  },
});

var app = new Vue({
  el: "#home-service",

  data: {
    step: "main", // main, develop, design, mobileapp, service-form
    getInTouchPayload: {
      fullname: null,
      email: null,
      phoneno: null,
      messenger: "Skype",
      imUsername: null,
      budget: "",
      captcha: null,
      service: "",
      subCategories: [],
    },
    errorMessages: {
      fullname: null,
      email: null,
      phoneno: null,
      imUsername: null,
      budget: "",
      captcha: null,
    },
    errors: [],
    stepError: "",
  },

  methods: {
    nextVisibility: function () {
      return getInTouchPayload.service != "" && step != "service-form";
    },

    saveGetTouchForm: function () {
      var errors = this.validateForm();

      // this.errors = errors;
      var self = this;
      if (errors.length < 1) {
        axios
          .post("/get-in-touch", self.getInTouchPayload)
          .then(function (response) {
            $("#home-service").modal("hide");
            // $('#home-service form').trigger("reset");
            $("#successful-msg h4").html("Successfuly sent");
            $("#successful-msg p").html(
              "Your request has been sent to admin. You will be contacted soon."
            );
            $("#successful-msg").modal("show");
            self.getInTouchPayload.fullname = null;
            self.getInTouchPayload.email = null;
            self.getInTouchPayload.phoneno = null;
            self.getInTouchPayload.imUsername = null;
            self.getInTouchPayload.budget = "";
            self.getInTouchPayload.captcha = null;
            self.getInTouchPayload.service = "";
            self.getInTouchPayload.subCategories = [];
            self.getInTouchPayload.messenger = "Skype";
            self.step = "main";
          })
          .catch(function (error) {
            console.log(error);
          });
        // alert("An admin will shortly get in touch with you!");
      }
    },

    validateForm() {
      var errors = [];
      // if(errorMessages.captcha != null) {
      // 	var errors = ['captcha'];
      // } else {
      // 	var errors = [];
      // }
      if (this.getInTouchPayload.budget == "") {
        errors.push("budget");
        this.errorMessages.budget = "Budget is a required field.";
      } else {
        this.errorMessages.budget = "";
      }
      if (
        this.getInTouchPayload.email == null ||
        $.trim(this.getInTouchPayload.email) == ""
      ) {
        errors.push("email");
        this.errorMessages.email = "Email is a required field.";
      } else if (!this.validEmail(this.getInTouchPayload.email)) {
        errors.push("email");
        this.errorMessages.email = "Enter a valid email id.";
      } else {
        this.errorMessages.email = "";
      }
      if (
        this.getInTouchPayload.fullname == null ||
        $.trim(this.getInTouchPayload.fullname) == ""
      ) {
        errors.push("fullname");
        this.errorMessages.fullname = "Full name is a required field.";
      } else {
        this.errorMessages.fullname = "";
      }
      if (
        this.getInTouchPayload.imUsername == null ||
        $.trim(this.getInTouchPayload.imUsername) == ""
      ) {
        errors.push("imUsername");
        this.errorMessages.imUsername = "IM Username is a required field.";
      } else {
        this.errorMessages.imUsername = "";
      }
      if (
        this.getInTouchPayload.phoneno == null ||
        $.trim(this.getInTouchPayload.phoneno) == ""
      ) {
        errors.push("phoneno");
        this.errorMessages.phoneno = "Phone number is a required field.";
      } else if (!validatePhone(this.getInTouchPayload.phoneno)) {
        errors.push("phoneno");
        this.errorMessages.phoneno = "Phone number can be only of 10 digit.";
      } else {
        this.errorMessages.phoneno = "";
      }
      var response = grecaptcha.getResponse();
      if (response.length == 0) {
        errors.push("captcha");
        this.errorMessages.captcha = "Captcha is required";
      } else {
        this.errorMessages.captcha = "";
        this.getInTouchPayload.captcha = response;
      }
      // var captchaResponse = grecaptcha.getResponse(opt_widget_id)
      return errors;
    },

    validEmail: function (email) {
      var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      // console.log(email, re.test(email));
      return re.test(email);
    },

    checkForCaptcha: function () {},

    selectSubCategory: function (subCat) {
      if (this.getInTouchPayload.subCategories.indexOf(subCat) === -1) {
        this.getInTouchPayload.subCategories.push(subCat);
      } else {
        this.getInTouchPayload.subCategories.splice(
          this.getInTouchPayload.subCategories.indexOf(subCat),
          1
        );
      }
      this.stepError = "";
    },

    paginate(dir) {
      if (dir == "prev") {
        if (
          this.step == "develop" ||
          this.step == "design" ||
          this.step == "mobileapp"
        ) {
          this.step = "main";
        } else if (this.step == "service-form") {
          if (this.getInTouchPayload.service == "development") {
            this.step = "develop";
          } else if (this.getInTouchPayload.service == "designing") {
            this.step = "design";
          } else if (this.getInTouchPayload.service == "mobileapp") {
            this.step = "mobileapp";
          }
        }
      } else {
        switch (this.step) {
          case "main":
            if (this.getInTouchPayload.service == "development") {
              this.step = "develop";
            } else if (this.getInTouchPayload.service == "designing") {
              this.step = "design";
            } else if (this.getInTouchPayload.service == "mobileapp") {
              this.step = "mobileapp";
            }
            break;
          case "develop":
            if (this.getInTouchPayload.subCategories.length > 0) {
              this.step = "service-form";
              this.stepError = "";
            } else {
              this.stepError = "Select atleast one category.";
            }
            break;
          case "design":
            if (this.getInTouchPayload.subCategories.length > 0) {
              this.step = "service-form";
              this.stepError = "";
            } else {
              this.stepError = "Select atleast one category.";
            }
            break;
          case "mobileapp":
            if (this.getInTouchPayload.subCategories.length > 0) {
              this.step = "service-form";
              this.stepError = "";
            } else {
              this.stepError = "Select atleast one category.";
            }
            break;
          case "service-form":
            if (this.getInTouchPayload.subCategories.length > 0) {
              this.step = "service-form";
            } else {
            }
            break;
        }
      }
    },
  },
});

var footerGetInTouch = new Vue({
  el: "#footer-get-in-touch",

  data: {
    getInTouchPayload: {
      fullname: null,
      email: null,
      phoneno: null,
      message: null,
    },
    errorMessages: {
      fullname: null,
      email: null,
      phoneno: null,
      message: null,
      captcha: null,
    },
    errors: [],
  },

  methods: {
    saveGetTouchForm: function (event) {
      console.log("event is here!");
      event.preventDefault();
      var errors = this.validateForm();
      // this.errors = errors;
      var self = this;
      if (errors.length < 1) {
        axios
          .post("/footer-get-in-touch", self.getInTouchPayload)
          .then(function (response) {
            equpTraceFormSubmission(
              document.getElementById("footer-get-in-touch")
            );
            $("#footer-get-in-touch").trigger("reset");
            $("#successful-msg h4").html("Successfuly sent");
            $("#successful-msg p").html(
              "Your REQUEST has been sent to ADMIN. You will be contacted soon."
            );
            $("#successful-msg").modal("show");
          })
          .catch(function (error) {
            console.log(error);
          });
        // alert("An admin will shortly get in touch with you!");
      }
    },

    validateForm() {
      var errors = [];
      // if(errorMessages.captcha != null) {
      //  var errors = ['captcha'];
      // } else {
      //  var errors = [];
      // }
      if (
        this.getInTouchPayload.email == null ||
        $.trim(this.getInTouchPayload.email) == ""
      ) {
        errors.push("email");
        this.errorMessages.email = "Email is a required field.";
      } else if (!this.validEmail(this.getInTouchPayload.email)) {
        errors.push("email");
        this.errorMessages.email = "Enter a valid email id.";
      } else {
        this.errorMessages.email = "";
      }
      if (
        this.getInTouchPayload.fullname == null ||
        $.trim(this.getInTouchPayload.fullname) == ""
      ) {
        errors.push("fullname");
        this.errorMessages.fullname = "Full name is a required field.";
      } else {
        this.errorMessages.fullname = "";
      }
      if (
        this.getInTouchPayload.message == null ||
        $.trim(this.getInTouchPayload.message) == ""
      ) {
        errors.push("message");
        this.errorMessages.message = "Message is a required field.";
      } else {
        this.errorMessages.message = "";
      }
      if (
        this.getInTouchPayload.phoneno == null ||
        $.trim(this.getInTouchPayload.phoneno) == ""
      ) {
        errors.push("phoneno");
        this.errorMessages.phoneno = "Contact number is a required field.";
      } else if (!validatePhone(this.getInTouchPayload.phoneno)) {
        errors.push("phoneno");
        this.errorMessages.phoneno = "Phone number can be only of 10 digit.";
      } else {
        this.errorMessages.phoneno = "";
      }
      // var response = grecaptcha.getResponse();

      // if(response.length == 0) {
      //   errors.push('captcha');
      //     this.errorMessages.captcha = "Captcha is required";
      // } else {
      //   this.errorMessages.captcha = "";
      //   this.getInTouchPayload.captcha = response;
      // }
      return errors;
    },

    validEmail: function (email) {
      var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      // console.log(email, re.test(email));
      return re.test(email);
    },
  },
});

/**
 *
 * this function accepts phone to check validation of it.
 * and returns boolean status...
 **/

function validatePhone(phone) {
  var re = /^[ ()+]*([0-9][ ()+]*){10}$/;
  return re.test(phone);
}

/**
 *
 *
 */
function handleFiles(files) {
  for (var i = 0; i < files.length; i++) {
    var file = files[i];

    if (!file.type.startsWith("image/")) {
      continue;
    }

    var img = document.createElement("img");
    img.classList.add("obj");
    img.file = file;
    preview.appendChild(img); // Assuming that "preview" is the div output where the content will be displayed.

    var reader = new FileReader();
    reader.onload = (function (aImg) {
      return function (e) {
        aImg.src = e.target.result;
      };
    })(img);
    reader.readAsDataURL(file);
  }
}

/**
 *
 *
 */
var hiringForm = new Vue({
  el: "#join-now",

  data: {
    filelist: {},
    getInTouchPayload: {
      fullname: null,
      jobapplyfor: null,
      email: null,
      phoneno: null,
      message: null,
      // fileupload: null
    },
    errorMessages: {
      fullname: null,
      email: null,
      phoneno: null,
      message: null,
      jobapplyfor: null,
      fileupload: null,
    },
    errors: [],
  },

  methods: {
    applyJobForm: function () {
      var errors = this.validateForm();
      // this.errors = errors;
      if (errors.length < 1) {
        var self = this;
        var form = document.querySelector("#applyNowForm");
        var file = self.filelist[0];
        var oData = new FormData();
        for (key in self.getInTouchPayload) {
          if (key != "recipients") {
            oData.append(key, self.getInTouchPayload[key]);
          }
        }
        oData.append("file", file, file.name);

        axios
          .post("/hiring-request", oData)
          .then(function (response) {
            if (response.status == 200) {
              $("#join-now").modal("hide");
              $("#applyNowForm").trigger("reset");
              $("#successful-msg h4").html("Successfuly sent");
              $("#successful-msg p").html(
                "Your resume has been sent to hr department. You will be contacted soon."
              );
              $("#successful-msg").modal("show");
            }
          })
          .catch(function (error) {
            console.log(error);
          });
        // alert("An admin will shortly get in touch with you!");
      }
    },

    validateForm() {
      var errors = [];
      // if(errorMessages.captcha != null) {
      //  var errors = ['captcha'];
      // } else {
      //  var errors = [];
      // }
      if (
        this.getInTouchPayload.email == null ||
        $.trim(this.getInTouchPayload.email) == ""
      ) {
        errors.push("email");
        this.errorMessages.email = "Email is a required field.";
      } else if (!this.validEmail(this.getInTouchPayload.email)) {
        errors.push("email");
        this.errorMessages.email = "Enter a valid email id.";
      } else {
        this.errorMessages.email = "";
      }
      if (
        this.getInTouchPayload.fullname == null ||
        $.trim(this.getInTouchPayload.fullname) == ""
      ) {
        errors.push("fullname");
        this.errorMessages.fullname = "Full name is a required field.";
      } else {
        this.errorMessages.fullname = "";
      }
      if (
        this.getInTouchPayload.message == null ||
        $.trim(this.getInTouchPayload.message) == ""
      ) {
        errors.push("message");
        this.errorMessages.message = "Message is a required field.";
      } else {
        this.errorMessages.message = "";
      }
      if (
        this.getInTouchPayload.phoneno == null ||
        $.trim(this.getInTouchPayload.phoneno) == ""
      ) {
        errors.push("phoneno");
        this.errorMessages.phoneno = "Contact number is a required field.";
      } else if (isNaN(this.getInTouchPayload.phoneno)) {
        errors.push("phoneno");
        this.errorMessages.phoneno = "Enter a valid Phone number.";
      } else {
        this.errorMessages.phoneno = "";
      }
      // console.log(this.filelist, this.filelist.length);
      if (this.filelist.length == undefined || this.filelist.length == 0) {
        errors.push("fileupload");
        this.errorMessages.fileupload = "Upload a valid pdf/doc.";
      } else {
        this.errorMessages.fileupload = "";
      }
      return errors;
    },

    validEmail: function (email) {
      var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      // console.log(email, re.test(email));
      return re.test(email);
    },

    filesChange: function (name, files) {
      this.$nextTick(function () {
        this.filelist = files;
      });
    },
  },
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js